import type { SecondaryMarketLimitOrderReloadFormFetched } from 'state/secondaryMarket/limit-order/form/input/inputForm.actions';
import type { SecondaryMarketLimitOrderInitFormFetched } from 'state/secondaryMarket/limit-order/limitOrder.actions';
import { referentialReducerFactory } from 'state/secondaryMarket/shared/referential/referential.reducer';

export const limitOrderReferentialReducer = referentialReducerFactory<
  'LIMIT_ORDER',
  SecondaryMarketLimitOrderInitFormFetched | SecondaryMarketLimitOrderReloadFormFetched
>('LIMIT_ORDER', (_: SecondaryMarketLimitOrderInitFormFetched | SecondaryMarketLimitOrderReloadFormFetched) => ({}));
